import React, { Fragment, useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
// Material UI
import {
  Typography
} from '@mui/material';
// Components
import { Button } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';
// Actions
import {
  deleteDriver,
  openDriverDeleteModal,
  clearRedux
} from "Redux/actions";
import { resetDriverDeleteDriverState } from "./redux/slice";

const DeleteDriver = (props) => {
  // Intl
  const { messages } = useIntl();

  //props 
  const { callback } = props;

  // Hooks
  const dispatch = useDispatch();

  // State local
  const { 
    loading, 
    openDelete, 
    filters, 
    selectedItems: items,
    driverResponse,
    error
  } = useSelector((state) => state.driverDeleteDriverSliceRedux);

  useEffect(() => {
    if (error) {
      const errorMessage = error.error === "CompanyReadonly" ? error.error : messages["settingsDriver_errorMessageDeleteDriver"];
      NotificationManager.error(
        errorMessage,
        messages['error'],
        3000,
        null,
        null,
        'warning',
      );

      dispatch(resetDriverDeleteDriverState());
    }
  }, [error])

  const handleClose = useCallback(() => {
    dispatch(openDriverDeleteModal(false));
    dispatch(clearRedux("SETTINGS_DRIVER", {
      openDelete: false,
      selectedItems: null,
      loading: false
    }));
  });

  useEffect(() => {
    if (driverResponse && openDelete) {
      NotificationManager.success(
        messages['settingsDriver_deleted'],
        messages['success'],
        3000,
        null,
        null,
        'success',
      );
      callback();
      handleClose();
    }
}, [driverResponse, openDelete]);

  return (
    <Fragment>
			<Modal
				title={messages["settingsDriver_delete"]}
				open={openDelete}
				size="small"
				handleClose={handleClose}
				position="right"
				loading={loading}
			>
				<ModalBody style={{ padding: 25 }}>
          <Typography
            variant="subtitle2"
            color="textSecondary"
          >
            {messages["settingsDriver_descriptonDelete"]}
          </Typography>
          <ul>
            {items?.map((item, key) => {
              return (
                <li key={item?.driverId || item?.id || key}>
                  {item.name.length > 50 ? item.name.substring(0, 50) + "..." : item.name }
                </li>
              )
            })}
          </ul>
				</ModalBody>
				<ModalFooter>
					<Button 
            onClick={handleClose} 
            className="btn-cancel"
          >
						{messages["cancel"]}
					</Button>
					<Button
						id={'btn-schedule'}
						type="button"
						onClick={(e) => {
              if (e) e.preventDefault();
              dispatch(deleteDriver({ items }));
            }}
						className="btn-red"
					>
						{messages["delete"]}
					</Button>
				</ModalFooter>
			</Modal>
		</Fragment>
  );
}

export default DeleteDriver;